// React & Nextjs imports
import React from "react";
// import Image from "next/image";

// Hooks & Utils
// import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";

// Components
import ICMWrapper from "@/app/components/icm-wrapper";
import { productRoute, ProductRoute } from "@/types/product";
import WhyInvestEtf1 from "@/app/assets/icons/why-invest-etf-1";
import WhyInvestEtf2 from "@/app/assets/icons/why-invest-etf-2";
import WhyInvestEtf3 from "@/app/assets/icons/why-invest-etf-3";
import WhyInvestEtf4 from "@/app/assets/icons/why-invest-etf-4";

// UI Components
// import { IconButton } from "@/stories/icon-button/icon-button";
// import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

// Icons
// import Bulb from "@/app/assets/icons/bulb";

interface WhyUsStocksProps {
    title: string;
    subtitle: string;
    icon: React.ReactNode;
}

interface Props {
    pageRoute: ProductRoute;
}

export default function WhyInvest({ pageRoute }: Props) {
    const stocks: WhyUsStocksProps[] = [
        {
            title: "Seamless onboarding experience",
            subtitle: "",
            icon: (
                <div className="mb-5">
                    <WhyInvestEtf2 />
                </div>
            ),
        },
        {
            title: "Access to US-listed stocks in one platform",
            subtitle: "",
            icon: (
                <div className="mb-5">
                    <WhyInvestEtf1 />
                </div>
            ),
        },
        {
            title: "Simple and transparent investing process",
            subtitle: "",
            icon: (
                <div className="mb-5">
                    <WhyInvestEtf3 />
                </div>
            ),
        },
        {
            title: "Integrated portfolio tracking",
            subtitle: "",
            icon: (
                <div className="mb-5">
                    <WhyInvestEtf4 />
                </div>
            ),
        },
    ];

    const etfs: WhyUsStocksProps[] = [
        {
            title: "Access to globally listed ETFs",
            subtitle: "",
            icon: (
                <div className="mb-5">
                    <WhyInvestEtf1 />
                </div>
            ),
        },
        {
            title: "Simple onboarding experience",
            subtitle: "",
            icon: (
                <div className="mb-5">
                    <WhyInvestEtf2 />
                </div>
            ),
        },
        {
            title: "Simple and transparent investing process",
            subtitle: "",
            icon: (
                <div className="mb-5">
                    <WhyInvestEtf3 />
                </div>
            ),
        },
        {
            title: "Integrated portfolio tracking",
            subtitle: "",
            icon: (
                <div className="mb-5">
                    <WhyInvestEtf4 />
                </div>
            ),
        },
    ];

    return (
        <div className={`${pageRoute === productRoute["us-stocks"] ? "" : ""}`}>
            <ICMWrapper>
                <div className="flex flex-col items-center py-s15 md:py-s20 md:pb-s16">
                    <h2 className="mb-5 md:mb-2 text-center text-4xl font-semibold -tracking-[0.56px] md:text-6xl md:leading-[67.2px]">
                        Why Invest Through InCred Money
                    </h2>
                    <p className="m-auto mb-12 text-center text-[#494F6E] md:text-left">
                        At InCred Money, we focus on making global investing accessible without
                        unnecessary complexity.
                    </p>
                    <div className="mb-16 flex flex-col items-center justify-between gap-16 md:flex-row md:flex-wrap md:gap-20">
                        {(pageRoute === productRoute["us-stocks"] ? stocks : etfs).map(
                            (item, index) => (
                                <div
                                    key={index}
                                    className="flex flex-col items-center justify-center text-center align-middle md:w-[17%]"
                                >
                                    {item.icon}
                                    <h3 className="mb-2 text-lg font-semibold leading-[130%]">
                                        {item.title}
                                    </h3>
                                    {item.subtitle && (
                                        <p
                                            className="text-center text-sm font-regular leading-[22.4px] tracking-[0.6px]"
                                            dangerouslySetInnerHTML={{ __html: item.subtitle }}
                                        ></p>
                                    )}
                                </div>
                            ),
                        )}
                    </div>

                    {/* <RegularButton
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        className="w-full max-w-full border-neutralOpacityLight-30 text-white hover:text-black md:max-w-fit"
                        label="Start Investing"
                        onClick={() => {
                            setAnalyticsEvent(
                                `${process.env.ICM_UE_URL || ""}/login`,
                                "US_Listing_Page_Start_Investing",
                            );
                            window.location.href = `${process.env.ICM_UE_URL || ""}/login`;
                        }}
                    /> */}
                </div>
            </ICMWrapper>
        </div>
    );
}
